import React,{useState,useEffect} from "react";
import Image from "../../components/common/Image";
import { updateInfo } from "../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import IdentityInfo from "../../components/service/identityInfo";

const Step2 = ({setStep, navigate}) => {
  const [selected, setSelected] = useState({})
  const user = useSelector(state => state.user)
  const [options, setOptions] = useState(null)
  const [modal, setModal] = useState(null)
  useEffect(() => {
    if(user){
      user.info && setSelected(user.info)
      let ids = []
      if(user.identities ){
        user.identities.ids.forEach(i=>{
          i.data?.forEach(d=>ids.push({...i,...d}))
        })
      } 
      setOptions(ids)
    }
  }, [user]);

  const dispatch = useDispatch()

  return (
   <>
    <div className="grid-space-200 page_with_footer">
      {options && options.map((option,i) => (
        <div className="d-flex radio-info-block" 
        key={option.offer_pno}
        onClick={()=>{
            let obj = selected.offer_pno === option.offer_pno? null :option
            setSelected(obj?obj:{})
            dispatch(updateInfo(obj))
            if(obj)navigate("/services")
           }}
        >
          <div className="radio-container"
           
          >
            <input type="radio" name="radio-group" 
            checked={selected.offer_pno === option.offer_pno} />
            <label for="test1"></label>
          </div>
          <div className="radio-block">
          
            <div className="block">
              <p className="title">{option.offer_pnoname}</p>
              {/* <p className="text">{option.bank}</p> */}
              <p className="text">{moment(option.expired_date).format("YYYY 年 MM 月 DD 日")}</p>
              <p className="text">{option.car_no}・限用</p>
              {/* <p className="text">{option.crm_0800}</p> */}
            </div>
            <button
            onClick={(e)=>{
              e.stopPropagation()
              setModal(option)
            }}
            >
              <Image src="/images/icons/chevron_right.svg" />
            </button>
          </div>
        </div>
      ))}
    </div>
    <div className='page_footer'>
      <button className='btn' onClick={()=>{
        navigate("/identity?key=1")
        // setStep(1)
      }}>帶入更多優惠身份</button>
    </div>
    {
      modal && <IdentityInfo setModal={setModal} data={modal} />
    }
    
    </>
  );
};

export default Step2;
